import "./ThinkingHeading.css";
import { formatDurationClockShort } from "@ui/format";
import { HStack } from "@ui/Stack.tsx";
import { TextMono } from "@ui/typography/TextMono";
import { useThinkingElapsedSeconds } from "./useThinkingElapsedSeconds.ts";

export const ThinkingHeading = (props: {
	startedAtMs: number;
	thinkingEndedAtMs?: number;
}) => {
	const displaySeconds = useThinkingElapsedSeconds(props);

	return (
		<HStack
			class="thinking-heading"
			classList={{ "is-active": props.thinkingEndedAtMs === undefined }}
			spacing="medium"
		>
			<TextMono class="thinking-heading__label" color="fg2">
				Thinking...
			</TextMono>
			<TextMono color="fg3">
				{formatDurationClockShort(displaySeconds())}
			</TextMono>
		</HStack>
	);
};
